module.exports = __webpack_public_path__ + "img/xavien_howard.6f1f4429.png";